"use strict";

import template from "./template.jade";
import FinanzierungDetailliertController from "../finanzierung_detailliert_betragsrechner/controller";

export default {
  template: template(),
  controller: FinanzierungDetailliertController,
  controllerAs: "ctx",
  bindings: {
    rechner: "=",
    posmodel: "=",
    errors: "=",
    extras: "=",
    kontext: "=?",
    vorschau: "=",
    prefix: "<?"
  },
};
